<!-- @format -->

<template>
    <div>
        <div
            ref="listContainer"
            :style="{ maxHeight: dynamicMaxHeightFormatted }"
            class="gst-list__items overflow-hidden mt-1">
            <span
                v-for="(item, k) in items"
                ref="listItem"
                :key="k"
                class="d-inline-block gst-list__item-pill">
                {{ item }} <br />
            </span>
        </div>

        <slot
            name="actions"
            :show-action="hasOverflowElements"></slot>
    </div>
</template>

<script>
import throttle from 'lodash/throttle';

export default {
    name: 'DynamicHeightInlineList',
    props: {
        items: {
            type: Array,
            default: () => [],
            required: true,
        },
        numberOfRows: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            listHeightVisible: undefined,
            listContainerHeight: undefined,
        };
    },
    computed: {
        dynamicMaxHeightFormatted() {
            return this.listHeightVisible + 'px';
        },
        hasOverflowElements() {
            return this.listContainerHeight > this.listHeightVisible;
        },
    },
    watch: {
        numberOfRows: {
            handler() {
                this.$nextTick(() => {
                    this.calculateListContainerHeight();
                });
            },
            immediate: true,
        },
    },
    methods: {
        calculateListContainerHeight() {
            if (this.$refs?.listItem) {
                const listItem = this.$refs?.listItem[0];
                const listItemHeight = listItem?.offsetHeight;
                const listItemComputedStyle = window.getComputedStyle(listItem, null);
                const listItemMargin =
                    parseInt(listItemComputedStyle.getPropertyValue('margin-top')) +
                    parseInt(listItemComputedStyle.getPropertyValue('margin-bottom'));
                this.listHeightVisible = (listItemHeight + listItemMargin) * this.numberOfRows;
                this.listContainerHeight = this.$refs?.listContainer.scrollHeight;
            }
        },
        handleResize: throttle(function () {
            this.calculateListContainerHeight();
        }, 200),
    },
    async mounted() {
        await this.handleResize();
        this.$nextTick(() => {
            this.calculateListContainerHeight();
        });
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>
